import React from 'react';
import { Chip } from '@mui/material';

/**
 * Badge outlined pour un type de conteneur (AB, PAV, BAC, ...).
 * Pendant neutre de `DechetTypeChip` — même API.
 */
function ConteneurTypeChip({ type, label, size = 'small', sx, ...rest }) {
    if (!type) return null;
    return (
        <Chip
            size={size}
            variant="outlined"
            label={label ?? type}
            sx={sx}
            {...rest}
        />
    );
}

export default ConteneurTypeChip;
